function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.588 7.416a.11.11 0 0 0 .011.005 6.137 6.137 0 0 1 1.72 1.09.052.052 0 0 1-.036.09h-.002c-.487 0-.944.123-1.344.337a.133.133 0 0 1-.133-.005 4.895 4.895 0 0 0-2.61-.744A4.902 4.902 0 0 0 2.7 9.64a4.927 4.927 0 0 0-1.446 3.374.132.132 0 0 1-.132.128H.132a.132.132 0 0 1-.131-.135c.015-.784.18-1.557.485-2.28a6.165 6.165 0 0 1 1.327-1.973 6.152 6.152 0 0 1 1.97-1.33l.01-.004.01-.005-.001-.001a4.092 4.092 0 0 1-1.693-3.32A4.088 4.088 0 0 1 6.193.002a4.09 4.09 0 0 1 4.086 4.094 4.095 4.095 0 0 1-1.692 3.32h.001zm0 0zm1.731 1.094a6.135 6.135 0 0 0-1.712-1.087L0 13.007a.132.132 0 0 0 .132.136h.99c.07 0 .13-.058.131-.13A4.926 4.926 0 0 1 2.7 9.642a4.902 4.902 0 0 1 3.495-1.452c.936 0 1.834.26 2.609.745a.134.134 0 0 0 .133.005 2.83 2.83 0 0 1 1.344-.337h.002c.05 0 .073-.06.036-.092zM4.19 6.103a2.817 2.817 0 0 0 2.005.832c.756 0 1.468-.296 2.005-.832.535-.537.83-1.25.83-2.008a2.827 2.827 0 0 0-.83-2.008 2.814 2.814 0 0 0-2.005-.833c-.758 0-1.47.296-2.005.833a2.827 2.827 0 0 0-.83 2.008 2.827 2.827 0 0 0 .83 2.008z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.001
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.069 13.97a1.644 1.644 0 1 0 0-3.287 1.644 1.644 0 0 0 0 3.288zM10.24 11.155l3.35-3.349M13.178 8.218l.822.821M11.945 9.45l.822.822",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgResourceType = function SvgResourceType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourceType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Resource Type.93ab03ee.svg";
export { ForwardRef as ReactComponent };